System.register(["./dyn-jsx-runtime.js", "./dyn-index.js", "./dyn-goober.modern.js", "./dyn-embla-carousel-react.esm.js", "./dyn-index2.js", "./dyn-index4.js", "./dyn-parallax-banner.js"], function(exports, module) {
  "use strict";
  var jsxRuntimeExports, clsx, reactExports, j, u, h, useEmblaCarousel, useMobile, scroll, animate;
  return {
    setters: [(module2) => {
      jsxRuntimeExports = module2.j;
      clsx = module2.c;
    }, (module2) => {
      reactExports = module2.r;
    }, (module2) => {
      j = module2.j;
      u = module2.u;
      h = module2.h;
    }, (module2) => {
      useEmblaCarousel = module2.u;
    }, (module2) => {
      useMobile = module2.u;
    }, (module2) => {
      scroll = module2.s;
    }, (module2) => {
      animate = module2.a;
    }],
    execute: function() {
      exports("default", Milestones);
      const SPEED_RATE = 1.5;
      const MainWrapper = j("div", reactExports.forwardRef)`
  position: relative;

  h3 {
    font-size: 60px;
    font-weight: 600;
    line-height: 72px;
    margin-bottom: 16px;
  }

  p.desc {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 12px;
  }

  .sticky-content {
    position: sticky;
    top: 30vh;
  }

  &.mobile .sticky-content {
    position: relative;
    top: initial;
  }

  .scroll-padding .milestones-padding--item {
    height: ${(props) => {
        var _a, _b;
        return 482 / SPEED_RATE * (((_a = props.items) == null ? void 0 : _a.length) || 0) / (((_b = props.items) == null ? void 0 : _b.length) || 1);
      }}px;
    pointer-events: none;
  }

  @media screen and (max-width: 767px) {
    h3,p {
      margin-left: 10px;
      margin-right: 10px;
      text-align: center;
    }
    h3 {
      font-size: 32px;
      line-height: 1.2;
    }
    p.desc {
      font-size: 14px;
      line-height: 1.35;
      max-width: 70vw;
      margin-left: auto;
      margin-right: auto;
    }
    .scroll-padding {
      display: none;
    }
  }
`;
      const NavItem = j("div")`
  display: inline-block;
  padding: 0px 20px;
  border-radius: 8px;
  color: #fff;
  font-weight: 600;
  margin-right: 12px;
  margin-bottom: 12px;
  cursor: pointer;

  font-size: 18px;
  line-height: 36px;
  vertical-align: top;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  &.active {
    background: linear-gradient(90deg, #35ebff 0%, #025bff 100%);
    font-size: 24px;
  }
  @media screen and (max-width: 767px) {
    font-size: 14px;
    line-height: 40px;
    padding: 0 14px;
    &.active {
      font-size: 18px;
    }
  }
`;
      const NavItems = j("div", reactExports.forwardRef)({
        overflow: "hidden",
        "@media screen and (max-width: 767px)": {
          marginLeft: "10px"
        }
      });
      const NavContainer = j("div")`
  display: flex;
  flex-wrap: nowrap;
`;
      const viewportCls = u`
  --slide-spacing: 10px;
  --slide-size: 482px;
  &.carousel {
    position: relative;
    overflow: hidden;
    padding-left: 10px;
    padding-right: 10px;

    --slide-size: calc(85vw + 20px);

    ul {
      display: flex;
      touch-action: pan-y pinch-zoom;
      margin-left: calc(var(--slide-spacing) * -1);
      margin-right: calc(var(--slide-spacing) * -1);
    }
  }
`;
      const ItemContainer = j("ul", reactExports.forwardRef)`
  display: flex;
  list-style: none;
  margin-left: -10px;
  margin-right: -10px;
  padding-left: 0;
  flex-wrap: nowrap;
`;
      const shakeEffect = h`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
`;
      const Item = j("li")`
  min-width: 0;
  transform: translate3d(0, 0, 0);
  box-sizing: border-box;
  flex: 0 0 var(--slide-size);
  padding-left: var(--slide-spacing);
  padding-right: var(--slide-spacing);

  &.extra-item {
    flex-shrink: 0;
    flex-grow: 1;
    flex-basis: auto;
    .item-content {
      width: auto;
      padding: 0;
      padding-top: 38px;
      &:hover {
        animation: none;
        img.initial-img {
          opacity: 1;
        }
      }
      h5 {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
      }
      img {
        position: static;
        width: 100%;
        height: auto;
      }
    }
    @media screen and (max-width: 1439px) {
      display: none;
    }
    @media screen and (max-width: 767px) {
      display: none;
    }
  }

  .item-content {
    position: relative;
    width: 462px;
    height: 240px;
    box-sizing: border-box;
    padding-top: 80px;
    padding-left: 240px;
    padding-right: 12px;
    border-radius: 8px;
    user-select: none;
    text-align: center;
    cursor: pointer;
    transform-origin: center center 5px;
    -webkit-tap-highlight-color: transparent;
    h5,
    p {
      position: relative;
      margin: 0;
      text-align: left;
      z-index: 1;
    }
    h5 {
      font-size: 26px;
      font-weight: 600;
      line-height: 32px;
    }
    p {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      em {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
      }
    }
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center bottom;
      pointer-events: none;
      z-index: 0;
      transition: opacity 0.3s;
      &.hover-img {
        opacity: 0;
      }
    }
    &:hover {
      animation: ${shakeEffect} 0.5s ease-in;
      img.initial-img {
        opacity: 0;
      }
      img.hover-img {
        opacity: 1;
      }
    }
    @media screen and (max-width: 767px) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      width: 85vw;
      height: 46.2691vw;
      padding-top: 0;
      padding-left: 42.4731vw;
      padding-right: 12px;
      &:hover {
        animation: none;
      }
    }
  }
`;
      const useDotButton = (emblaApi) => {
        const [selectedIndex, setSelectedIndex] = reactExports.useState(0);
        const [scrollSnaps, setScrollSnaps] = reactExports.useState([]);
        const onDotButtonClick = reactExports.useCallback((index) => {
          if (!emblaApi) return;
          emblaApi.scrollTo(index);
        }, [emblaApi]);
        const onInit = reactExports.useCallback((emblaApi2) => {
          setScrollSnaps(emblaApi2.scrollSnapList());
        }, []);
        const onSelect = reactExports.useCallback((emblaApi2) => {
          setSelectedIndex(emblaApi2.selectedScrollSnap());
        }, []);
        reactExports.useEffect(() => {
          if (!emblaApi) return;
          onInit(emblaApi);
          onSelect(emblaApi);
          emblaApi.on("reInit", onInit).on("reInit", onSelect).on("select", onSelect);
        }, [emblaApi, onInit, onSelect]);
        return {
          selectedIndex,
          scrollSnaps,
          onDotButtonClick
        };
      };
      function Milestones(props) {
        var _a;
        const {
          items = []
        } = props;
        const main = reactExports.useRef(null);
        const scrollRef = reactExports.useRef(null);
        const contentRef = reactExports.useRef(null);
        const isMobile = useMobile();
        const [emblaRef, emblaApi] = useEmblaCarousel({
          align: "start"
        });
        const [emblaNavRef, emblaNavApi] = useEmblaCarousel({
          align: "start",
          dragFree: true,
          inViewThreshold: 1
        });
        const [activeTitle, setActiveTitle] = reactExports.useState(items[0].title);
        const {
          selectedIndex,
          onDotButtonClick
        } = useDotButton(emblaApi);
        const onClickHandler = reactExports.useCallback((prefix) => {
          var _a2;
          if (isMobile) {
            const nodes = emblaApi == null ? void 0 : emblaApi.slideNodes();
            const index = items.findIndex((v) => v.title.startsWith(prefix));
            if (nodes && index >= 0) {
              onDotButtonClick(index);
              setActiveTitle(nodes[index].title);
            }
          } else {
            const el = (_a2 = main.current) == null ? void 0 : _a2.querySelector(`.scroll-padding [data-point*="${prefix}-"]`);
            if (el) {
              const rect = el.getBoundingClientRect();
              window.scrollTo({
                top: window.scrollY + rect.top,
                behavior: "smooth"
              });
            }
          }
        }, [emblaApi, isMobile]);
        reactExports.useEffect(() => {
          if (!emblaApi) return;
          function onSelect() {
            const index = emblaApi.selectedScrollSnap();
            const nodes = emblaApi.slideNodes();
            if (nodes && nodes[index]) {
              setActiveTitle(nodes[index].title);
              if (emblaNavApi) {
                const navSlidesInView = emblaNavApi.slidesInView();
                emblaApi == null ? void 0 : emblaApi.previousScrollSnap();
                const indexInSlidesInView = navSlidesInView.indexOf(index);
                const needScroll = indexInSlidesInView === -1;
                if (needScroll) {
                  const offset = Math.floor(navSlidesInView.length / 2);
                  if (emblaNavApi.selectedScrollSnap() > index && index - offset >= 0) {
                    emblaNavApi.scrollTo(index - offset);
                  } else {
                    if (index - offset >= 0) {
                      emblaNavApi == null ? void 0 : emblaNavApi.scrollTo(index - offset);
                    } else {
                      emblaNavApi == null ? void 0 : emblaNavApi.scrollTo(index);
                    }
                  }
                }
              }
            }
          }
          emblaApi.on("select", onSelect);
          return () => {
            emblaApi.off("select", onSelect);
          };
        }, [emblaApi, emblaNavApi]);
        reactExports.useEffect(() => {
          if (main.current && scrollRef.current) {
            const mainEl = main.current;
            if (isMobile) return;
            const extraItem = mainEl.querySelector(".extra-item");
            let unlistenResize = () => {
            };
            const containerEl = mainEl.querySelector("ul");
            if (extraItem) {
              let onResize = function() {
                var _a2;
                const parentWidth = parseInt(((_a2 = getComputedStyle(containerEl).width.match(/(\d+)/)) == null ? void 0 : _a2[1]) || "");
                extraItem.style.width = `${parentWidth - 482}px`;
              };
              window.addEventListener("resize", onResize);
              onResize();
              unlistenResize = () => {
                window.removeEventListener("resize", onResize);
              };
            }
            const length = items.length;
            const animation = animate(containerEl, {
              transform: [
                "none",
                // 需要改成更智能的计算值, 需要 -1 保证能看到最后一个
                `translateX(${-(items.length - 1) * 482}px)`
              ]
            }, {
              duration: 20,
              ease: "linear"
            });
            const unlistenTranslate = scroll((p) => {
              animation.time = animation.duration * p;
              animation.pause();
              const seg = 1 / length;
              const index = p === 1 ? length - 1 : Math.max(0, Math.ceil(p / seg % items.length) - 1);
              if (items[index]) {
                setActiveTitle(items[index].title);
              }
            }, {
              // container 使用 window 即可
              target: scrollRef.current,
              axis: "y",
              offset: ["start start", "end start"]
            });
            return () => {
              unlistenResize();
              unlistenTranslate();
            };
          }
        }, [isMobile]);
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(MainWrapper, { ref: main, items, className: clsx({
          mobile: isMobile
        }), children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "sticky-content", ref: contentRef, children: [
            props.heading && /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { children: props.heading }),
            props.desc && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "desc", children: props.desc }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(NavItems, { ref: emblaNavRef, children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavContainer, { children: Array.from(new Set(items.map((v) => v.title))).map((title, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(NavItem, { className: isMobile && selectedIndex === index || activeTitle === title ? "active" : void 0, onClick: () => onClickHandler(title), children: title }, `${title}-${index}`)) }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: isMobile ? emblaRef : void 0, className: clsx(viewportCls, {
              carousel: isMobile
            }), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ItemContainer, { children: [
              items.map((item, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(Item, { "data-point": `${item.title}-${index}`, onClick: () => onClickHandler(item.title), children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: clsx("item-content", {
                active: activeTitle === item.title
              }), children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("h5", { children: item.title }),
                item.desc && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { dangerouslySetInnerHTML: {
                  __html: item.desc
                } }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "initial-img", src: isMobile && item.image_mobile || item.image }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "hover-img", src: isMobile && item.image_hover_mobile || item.image_hover, loading: "lazy" })
              ] }) }, `item-${item.title},${index}`)),
              !isMobile && props.extra_item && /* @__PURE__ */ jsxRuntimeExports.jsx(Item, { className: "extra-item", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "item-content", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("h5", { children: props.extra_item_title }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "initial-img", src: props.extra_item, loading: "lazy" })
              ] }) }, "extra-item")
            ] }) })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "scroll-padding", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: scrollRef, children: items.slice(0, -1).map((item, index) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-point": `${item.title}-${index}`, className: "milestones-padding--item" }, `${item.title}-${index}`)) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-point": `${(_a = items.slice(-1).pop()) == null ? void 0 : _a.title}-0`, className: "milestones-padding--item" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
              height: "50vh"
            } })
          ] })
        ] });
      }
    }
  };
});
